module.exports = __webpack_public_path__ + "static/img/Logo_.06bde13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_.jpg
// module id = pT73
// module chunks = 1